import { useCurrentTenant } from "@drift/oneplatfront";
import { useAuth, useGet } from "@onefront/react-sdk";
import { WorkspaceDetailsDto } from "../../../@types/dtos/workspace/WorkspaceDetailsDto";
import { WorkspaceDetailsParams } from "../../../@types/params/WorkspaceDetailsParams";
import { generateHeaders } from "../../../utils/generate-headers";

interface WorkspaceDetailsParamsFetch {
    params?: WorkspaceDetailsParams;
    headers?: any;
}

interface UseGetWorkspaceDetailsData {
    (workspaceId?: string, params?: WorkspaceDetailsParams, lazy?: boolean): {
        data?: WorkspaceDetailsDto;
        loading?: boolean;
        fetch?: (fetchConfig?: WorkspaceDetailsParamsFetch) => Promise<any>;
        error?: boolean;
    };
}

export const useGetWorkspaceDetails: UseGetWorkspaceDetailsData = (workspaceId, params, lazy = false) => {
    const { tenant } = useCurrentTenant(true);
    return useGet(`rnd:core:workspace-read:api://v1/workspaces/${workspaceId}`, {
        params: {
            ownerId: tenant?.itemId,
            validityFrom: new Date().toISOString(),
            view: params?.view || "BASE"
        },
        headers: generateHeaders(useAuth(), tenant?.itemId),
        lazy
    });
};
